// extracted by mini-css-extract-plugin
module.exports = {"body":"BaseModal_body__31HMg"};